"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Answer;

var _Answer = require("@adobe/react-spectrum-workflow/dist/Answer");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Answer(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Answer.A4uAnswer, null));
}